import { useSubscriptionContext } from "@/contexts/SubscriptionContext";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

export const PlanBadge = () => {
  const { t } = useTranslation();
  const { plan, isLoading } = useSubscriptionContext();

  if (isLoading) {
    return (
      <Badge variant="outline" className="gap-2">
        <Loader2 className="h-3 w-3 animate-spin" />
        {t("common.loading")}
      </Badge>
    );
  }

  return (
    <Badge
      variant={plan.name === "Free" ? "outline" : "default"}
      className="capitalize"
    >
      {plan.name}
    </Badge>
  );
};